import {load} from '@shopify/theme-sections';

import initWishlist from '../components/wishlist-items';
import '../sections/product-recommendations';

document.addEventListener('DOMContentLoaded', () => {
  load('*');

  initWishlist();
});
